import type { IScenario } from 'commonTypes/api/scenarios/scenario';

import { isRecord, isRecordHasKey } from 'shared/lib/guards';

import type { ScenarioWithContentHeader } from '../types';

export const checkScenarioHasContentHeader = (
  scenario: IScenario | null | undefined,
): scenario is ScenarioWithContentHeader => {
  const content = scenario?.content;

  if (!isRecord(content)) {
    return false;
  }

  if (!isRecordHasKey(content, 'header')) {
    return false;
  }

  return typeof content.header === 'object' && content.header !== null;
};
